import {Injectable} from '@angular/core';
import {StorageMap} from '@ngx-pwa/local-storage';
import {BehaviorSubject, firstValueFrom, Observable} from 'rxjs';

@Injectable()
export class RememberEventService {
  public eventId = new BehaviorSubject<number>(-1);

  constructor(private storage: StorageMap) {
  }

  public setLastEvent(eventId: number): void {
    this.storage.set('currentEvent', eventId).subscribe(() => {
    });
  }

  public getLastEventId(): Promise<number> {
    return firstValueFrom((<Observable<number>>this.storage.get('currentEvent')));
  }

}
